import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notification: null,
  theme: false,
};

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    setSetting: (state, action) => {
      state.notification = action.payload.notification;
      state.theme = action.payload.theme;
     
    },
    distroySettting: (state) => {
      state.notification = null;
      state.theme = false;
    },
  },
});

export const { setSetting, distroySettting } = settingSlice.actions;
export default settingSlice.reducer;